import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewParteIngresos = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: '/parte_ingreso_wc',
        name: 'Parte de Ingresos',
        component: ViewParteIngresos,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
